import { MIN_PASSWORD_LENGTH } from "@shared/password-policy";
import {
  createRootRoute,
  Link,
  Outlet,
  useNavigate,
} from "@tanstack/react-router";
import { AuthProvider } from "@/components/auth/auth-provider";
import { Toaster } from "@/components/ui/sonner";
import { authClient } from "@/lib/auth-client";

function RootLayout() {
  const navigate = useNavigate();

  return (
    <AuthProvider
      authClient={authClient}
      navigate={navigate}
      socialProviders={["google", "apple"]}
      emailAndPassword={{
        requireEmailVerification: true,
        minPasswordLength: MIN_PASSWORD_LENGTH,
      }}
      redirectTo="/"
      Link={({ href, ...props }) => <Link to={href} {...props} />}
    >
      <Outlet />
      <Toaster />
    </AuthProvider>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
});

// Let routes declare a header title via `staticData: { title: "…" }`, read by
// layout headers (e.g. the _settings layout) from the active leaf match.
declare module "@tanstack/react-router" {
  interface StaticDataRouteOption {
    title?: string;
  }
}
